<template>
  <div
    class="flex flex-col gap-6 w-[650px] p-6 rounded-lg bg-white shadow-default"
  >
    <h2 class="modal-heading">
      {{ changeCase('add widget', ElementE.TITLE) }}
    </h2>

    <div class="w-full pt-2">
      <div class="relative">
        <label class="label-primary" for="add-widget-input">
          {{ changeCase('widget name', ElementE.LABEL) }}
        </label>
        <input
          id="add-widget-input"
          v-model.trim="widgetName"
          class="input-primary"
          :class="error && 'border-critical'"
          type="text"
          :placeholder="(changeCase('enter name', ElementE.PLACEHOLDER) as string)"
          @blur="validateField(widgetName)"
        />
        <div v-if="error">
          <div class="absolute top-3.5 right-3">
            <ErrorIcon />
          </div>
          <p class="mt-1 text-xs text-critical-main">
            {{ error }}
          </p>
        </div>
      </div>
    </div>

    <div class="flex gap-4 self-end">
      <button class="btn-secondary is-btn-size-default" @click="$emit('close')">
        {{ changeCase('cancel', ElementE.BUTTON) }}
      </button>
      <button class="btn-primary is-btn-size-default" @click="addNewWidget">
        {{ changeCase('add', ElementE.BUTTON) }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import { changeCase } from '../../helpers';
import { ElementE } from '../../enums';
import ErrorIcon from "../icons/ErrorIcon.vue";

const router = useRouter();

const widgetName = ref<string>("");
const error = ref<string>("");
const maxLength = 20;

const validateField = (value: string) => {
  if (!value) {
    error.value = "The field should not be empty";
    return;
  }
  
  if (value.length > maxLength) {
    error.value = `The length of field must be less than ${maxLength} characters`;
    return;
  }
  
  error.value = "";
};

const addNewWidget = async() => {
  const token = sessionStorage.getItem("TOKEN");
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const formData = new FormData();
  formData.append("name", widgetName.value);

  if (!widgetName.value) {
    error.value = "The field should not be empty"
  }

  if (!error.value) {
    try {
      const { data: { id }} = await axios.post(process.env.VUE_APP_API + "v3/widgets", formData, config);
      router.push({ name: "Edit Widget", params: { wid: id } });
    } catch (error) {
      console.error(error);
    }
  }
}
</script>
